import { createAction } from "@reduxjs/toolkit";

export const FETCH_LIST_REPORT_STUDENT_MODULE = 'FETCH_LIST_REPORT_STUDENT_MODULE';
export const GET_REPORT_STUDENT_PRACTICE_ACTIVITY = 'GET_REPORT_STUDENT_PRACTICE_ACTIVITY';
export const GET_REPORT_STUDENT_EXAM_ACTIVITY = 'GET_REPORT_STUDENT_EXAM_ACTIVITY';
export const FETCH_STUDENT_DASHBOARD_CLASS_MODULE_STATS = 'FETCH_STUDENT_DASHBOARD_CLASS_MODULE_STATS';
export const FETCH_DASHBOARD_STUDENT_V2 = 'FETCH_DASHBOARD_STUDENT_V2';
export const EXPORT_DASHBOARD_COMPLETION = 'EXPORT_DASHBOARD_COMPLETION';
export const EXPORT_DASHBOARD_PRACTICE_RESULTS = 'EXPORT_DASHBOARD_PRACTICE_RESULTS';

export const fetchListReportStudentModule = createAction(FETCH_LIST_REPORT_STUDENT_MODULE)

export const fetchReportStudentPracticeActivity = createAction(GET_REPORT_STUDENT_PRACTICE_ACTIVITY, (({module_id, start_date, end_date }:{module_id: number, start_date: string, end_date: string, status : 2}) => ({
  payload: {
    module_id,
    start_date,
    end_date,
    status: 2
  }
})))

export const fetchReportStudentExamActivity = createAction(GET_REPORT_STUDENT_EXAM_ACTIVITY, (({module_id, start_date, end_date }:{module_id: number, start_date: string, end_date: string}) => ({
  payload: {
    module_id,
    start_date,
    end_date
  }
})))

export const fetchStudentDashboardClassModuleStats = createAction(FETCH_STUDENT_DASHBOARD_CLASS_MODULE_STATS, (({class_id, from_date, to_date }:{class_id: number, from_date: string, to_date: string}) => ({
  payload: {
    class_id,
    from_date,
    to_date
  }
})))

export const fetchDashboardStudentV2 = createAction(FETCH_DASHBOARD_STUDENT_V2)
export const exportDashboardCompletion = createAction(EXPORT_DASHBOARD_COMPLETION)
export const exportDashboardPracticeResults = createAction(EXPORT_DASHBOARD_PRACTICE_RESULTS)

